"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5430],{

/***/ 51713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ LocalBusinessSchema; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42660);
/* harmony import */ var _components_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73739);



var LocalBusinessSchema = function(param) {
    var results = param.results;
    var serviceIdForMember = (0,_components_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_2__/* .usePageAttributes */ .l)().serviceIdForMember;
    var schemaType = serviceIdForMember === _constants__WEBPACK_IMPORTED_MODULE_1__/* .ServiceIdForMember.CHILD_CARE */ .u2.CHILD_CARE || serviceIdForMember === _constants__WEBPACK_IMPORTED_MODULE_1__/* .ServiceIdForMember.CHILD_CARE_LOCATION */ .u2.CHILD_CARE_LOCATION ? "ChildCare" : "LocalBusiness";
    var LocalBusinessList = function() {
        return results.map(function(searchResult) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            var _amount;
            var rateAmount = (_amount = (ref = searchResult.seoSegmentationProvider.providerRate) === null || ref === void 0 ? void 0 : ref.rate.amount) !== null && _amount !== void 0 ? _amount : (ref1 = searchResult.seoSegmentationProvider.costimate) === null || ref1 === void 0 ? void 0 : ref1.rate.amount;
            var ref7;
            var rateDuration = (ref7 = (ref2 = searchResult.seoSegmentationProvider.providerRate) === null || ref2 === void 0 ? void 0 : ref2.rateDuration) !== null && ref7 !== void 0 ? ref7 : (ref3 = searchResult.seoSegmentationProvider.costimate) === null || ref3 === void 0 ? void 0 : ref3.rateDuration;
            var hasCostimate = searchResult.seoSegmentationProvider.costimate;
            var localBusiness = {
                "@context": "https://schema.org/",
                "@type": schemaType,
                name: searchResult.seoSegmentationProvider.provider.name,
                image: (ref4 = searchResult.seoSegmentationProvider.provider.logo) === null || ref4 === void 0 ? void 0 : ref4.urlThumbnail,
                address: {
                    "@type": "PostalAddress",
                    addressLocality: (ref5 = searchResult.seoSegmentationProvider.provider.address) === null || ref5 === void 0 ? void 0 : ref5.city,
                    addressRegion: (ref6 = searchResult.seoSegmentationProvider.provider.address) === null || ref6 === void 0 ? void 0 : ref6.state
                }
            };
            if (rateAmount && rateDuration) {
                localBusiness.priceRange = hasCostimate ? "Costimate: $".concat(rateAmount, "/").concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .RATE_DURATION_ABBREVIATIONS */ .r7[rateDuration]) : "Starting at $".concat(rateAmount, "/").concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .RATE_DURATION_ABBREVIATIONS */ .r7[rateDuration]);
            }
            return localBusiness;
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
        "data-testid": "localBusinessSchema",
        type: "application/ld+json",
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(LocalBusinessList())
        }
    });
};


/***/ }),

/***/ 55430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HybridSearchDirectory": function() { return /* binding */ HybridSearchDirectory; },
  "default": function() { return /* binding */ page_HybridSearchDirectory; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/CoreGlobalFooter/CoreGlobalFooter.js + 12 modules
var CoreGlobalFooter = __webpack_require__(11566);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/@care/iterable-display/dist/index.js + 16 modules
var dist = __webpack_require__(46207);
// EXTERNAL MODULE: ./src/components/hooks/useFeatureFlag.ts
var useFeatureFlag = __webpack_require__(19500);
// EXTERNAL MODULE: ./src/components/common/IterableBanner.tsx
var IterableBanner = __webpack_require__(51016);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/context/searchDirectory/SearchDirectoryDataContext.tsx
var SearchDirectoryDataContext = __webpack_require__(32826);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/InternalLinkingSection.tsx + 1 modules
var InternalLinkingSection = __webpack_require__(53166);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/BreadcrumbsSection.tsx
var BreadcrumbsSection = __webpack_require__(38071);
// EXTERNAL MODULE: ./src/components/common/ArticleSection/ArticleSection.tsx
var ArticleSection = __webpack_require__(83845);
// EXTERNAL MODULE: ./src/helpers/getArticlesList.ts
var getArticlesList = __webpack_require__(73006);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/ReviewsSection/ReviewsSection.tsx + 2 modules
var ReviewsSection = __webpack_require__(3092);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/FAQSection.tsx
var FAQSection = __webpack_require__(96607);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js
var Container = __webpack_require__(46574);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./src/components/contexts/PageAttributesContext.tsx
var PageAttributesContext = __webpack_require__(73739);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/getHeroImage.ts
var getHeroImage = __webpack_require__(99661);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/BackgroundCheckTrustBadge.tsx + 1 modules
var BackgroundCheckTrustBadge = __webpack_require__(45594);
// EXTERNAL MODULE: ./src/helpers/getDefaultHeroImageLarge.ts
var getDefaultHeroImageLarge = __webpack_require__(80427);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ./node_modules/he/he.js
var he = __webpack_require__(86492);
var he_default = /*#__PURE__*/__webpack_require__.n(he);
// EXTERNAL MODULE: ./src/components/hooks/useResponsive.tsx
var useResponsive = __webpack_require__(19147);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/ZipCodeConversion.tsx
var ZipCodeConversion = __webpack_require__(34664);
// EXTERNAL MODULE: ./src/lib/analyticsHelper.tsx
var analyticsHelper = __webpack_require__(883);
;// CONCATENATED MODULE: ./src/components/page/HybridSearchDirectory/components/HeroConversionBox.tsx








var HeroConversionBox = function() {
    var pageData = (0,SearchDirectoryDataContext/* useSearchDirectoryData */.Q)();
    var isLargeViewport = (0,useResponsive/* useResponsive */.F)().isLargeViewport;
    var _seoSegmentationDetails = pageData.seoSegmentationDetails, headline = _seoSegmentationDetails.headline, subHeadline = _seoSegmentationDetails.subHeadline;
    var ctaText = "Get started";
    var handleCtaBtn = function() {
        var amplitudeData = {
            cta_text: ctaText,
            cta_type: "button"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)("CTA Interacted", amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            mb: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "h1",
                variant: isLargeViewport ? "display1" : "display2",
                color: "primary",
                sx: {
                    mb: {
                        xs: 2,
                        sm: 3
                    },
                    mt: 0
                },
                dangerouslySetInnerHTML: {
                    __html: sanitize_html_default()(he_default().decode(headline))
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "p",
                variant: "body2",
                mb: 4,
                dangerouslySetInnerHTML: {
                    __html: sanitize_html_default()(he_default().decode(subHeadline.replace(/<\/?p>/g, "")))
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ZipCodeConversion/* ZipCodeConversion */.y, {
                showZipCodeInputField: true,
                handleCtaBtn: handleCtaBtn,
                ctaText: ctaText
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/page/HybridSearchDirectory/components/section/HeroSection.tsx








var HeroSection = function() {
    var pageData = (0,SearchDirectoryDataContext/* useSearchDirectoryData */.Q)();
    var serviceId = pageData.seoSegmentationDetails.serviceId;
    var seoSegmentId = (0,PageAttributesContext/* usePageAttributes */.l)().seoSegmentId;
    var ref;
    var heroImage = (ref = (0,getHeroImage/* getHeroImage */.w)({
        seoSegmentId: seoSegmentId,
        serviceId: serviceId
    })) !== null && ref !== void 0 ? ref : (0,getDefaultHeroImageLarge/* getDefaultHeroImageLarge */.A)(pageData.seoSegmentationHeroImage);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: "lg",
        sx: {
            mt: {
                xs: 3,
                sm: 6,
                lg: 10
            },
            mb: {
                xs: 6,
                lg: 8
            },
            mx: "auto",
            px: {
                xs: 3,
                md: 0
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            sx: {
                flexDirection: {
                    xs: "column",
                    sm: "row"
                },
                alignItems: {
                    sm: "center"
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    item: true,
                    sm: 6,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroConversionBox, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mb: {
                                xs: 6,
                                sm: 0
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundCheckTrustBadge/* BackgroundCheckTrustBadge */.P, {})
                        })
                    ]
                }),
                heroImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        component: "img",
                        src: heroImage,
                        alt: "Hero image",
                        sx: {
                            width: "100%",
                            objectFit: "cover",
                            pl: {
                                sm: 4,
                                lg: 6
                            }
                        }
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/system/esm/Box/Box.js + 1 modules
var Box_Box = __webpack_require__(89609);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/Container/Container.js
var Container_Container = __webpack_require__(32045);
// EXTERNAL MODULE: ./src/components/page/CaregiverSearchDirectory/components/CaregiverStats.tsx + 2 modules
var CaregiverStats = __webpack_require__(32572);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./src/components/SearchResults/NoResults.tsx
var NoResults = __webpack_require__(61206);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/SearchResults.tsx
var SearchResults = __webpack_require__(53653);
// EXTERNAL MODULE: ./src/components/contexts/SegmentationFiltersContext.tsx
var SegmentationFiltersContext = __webpack_require__(99207);
// EXTERNAL MODULE: ./src/components/Filters/LocationFilter.tsx
var LocationFilter = __webpack_require__(13866);
// EXTERNAL MODULE: ./src/components/Filters/FiltersPopover.tsx
var FiltersPopover = __webpack_require__(61166);
// EXTERNAL MODULE: ./src/components/Filters/FiltersModal.tsx
var FiltersModal = __webpack_require__(88450);
// EXTERNAL MODULE: ./src/components/SearchResults/Pagination.tsx
var Pagination = __webpack_require__(6551);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/useSearchResults.ts + 1 modules
var useSearchResults = __webpack_require__(35950);
// EXTERNAL MODULE: ./src/__generated__/globalTypes.ts
var globalTypes = __webpack_require__(79967);
// EXTERNAL MODULE: ./src/components/page/CaregiverSearchDirectory/components/CaregiverCard/CaregiverCard.tsx
var CaregiverCard = __webpack_require__(44375);
// EXTERNAL MODULE: ./src/components/page/SMBSearchDirectory/components/SMBCard/SMBCard.tsx
var SMBCard = __webpack_require__(61083);
// EXTERNAL MODULE: ./src/components/page/CaregiverSearchDirectory/helpers/shouldShowUserFilters.ts
var shouldShowUserFilters = __webpack_require__(44514);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/ProductSchema.tsx
var ProductSchema = __webpack_require__(49366);
// EXTERNAL MODULE: ./src/helpers/narrowSegmentationStats.ts
var narrowSegmentationStats = __webpack_require__(21444);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/LocalBusinessSchema.tsx
var LocalBusinessSchema = __webpack_require__(51713);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/ItemListSchema.tsx
var ItemListSchema = __webpack_require__(87726);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/hooks/useSearchAdConfig.tsx
var useSearchAdConfig = __webpack_require__(92401);
// EXTERNAL MODULE: ./src/components/hooks/useLDClientFlags.tsx
var useLDClientFlags = __webpack_require__(32778);
// EXTERNAL MODULE: ./src/components/feature/searchDirectory/Illustration.tsx + 1 modules
var Illustration = __webpack_require__(85665);
;// CONCATENATED MODULE: ./src/components/page/HybridSearchDirectory/components/SearchResultsContainer.tsx




























// eslint-disable-next-line complexity
var SearchResultsContainer = function(param) {
    var Aside = param.Aside;
    var ref = (0,SearchDirectoryDataContext/* useSearchDirectoryData */.Q)(), seoSegmentationSearchResults = ref.seoSegmentationSearchResults, seoSegmentationDetails = ref.seoSegmentationDetails, seoSegmentationStats = ref.seoSegmentationStats;
    var ref1 = (0,PageAttributesContext/* usePageAttributes */.l)(), seoSegmentId = ref1.seoSegmentId, searchingFor = ref1.searchingFor;
    var initialCaregiverSearchResults = seoSegmentationSearchResults.caregiverSearchResults, initialProviderSearchResults = seoSegmentationSearchResults.providerSearchResults, initialFilters = seoSegmentationSearchResults.filters, initialPagination = seoSegmentationSearchResults.pagination;
    var segmentationStats = (0,narrowSegmentationStats/* narrowSegmentationStats */.f)(seoSegmentationStats);
    var ref2;
    var totalReviewCount = (ref2 = segmentationStats === null || segmentationStats === void 0 ? void 0 : segmentationStats.totalReviewCount) !== null && ref2 !== void 0 ? ref2 : null;
    var ref3;
    var avgReviewRating = (ref3 = segmentationStats === null || segmentationStats === void 0 ? void 0 : segmentationStats.avgReviewRating) !== null && ref3 !== void 0 ? ref3 : null;
    var showProductSchema = totalReviewCount !== null && totalReviewCount >= 5 && avgReviewRating !== null;
    var isNationalPage = seoSegmentationDetails.pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL;
    var showUserFilters = (0,shouldShowUserFilters/* shouldShowUserFilters */.J)(searchingFor ? globalTypes/* SEOSegmentationSearchingFor */.yh[searchingFor] : undefined, constants/* SERVICE_ID_FOR_MEMBER_TO_KEY */.e3[seoSegmentationDetails.serviceIdForMember]);
    var ref4 = (0,react.useState)(false), isVisible = ref4[0], setIsVisible = ref4[1];
    var searchFiltersRef = (0,react.useRef)(null);
    var searchResultRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var lastScrollY = window.scrollY;
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
            var isScrollingDown = window.scrollY > lastScrollY;
            lastScrollY = window.scrollY;
            if (entry.isIntersecting) {
                setIsVisible(true);
            } else if (!entry.isIntersecting && isScrollingDown) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        }, {
            threshold: 0.1
        });
        var currentSearchResult = searchResultRef.current;
        if (currentSearchResult) {
            observer.observe(currentSearchResult);
        }
        return function() {
            if (currentSearchResult) {
                observer.unobserve(currentSearchResult);
            }
        };
    }, []);
    var isExtraSmallViewport = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    }); // Mobile Phones
    var isSmallViewport = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.only("sm");
    }); // Small Tablets
    var asideLocation = function() {
        if (isSmallViewport || isExtraSmallViewport) return "TOP";
        return "BOTTOM";
    };
    var ref5 = (0,useLDClientFlags/* useLDClientFlags */.y)(), GAMFlag = ref5.SEO_3487_GAM_ADS_SEO_MFE;
    var showGAMAds = (GAMFlag === null || GAMFlag === void 0 ? void 0 : GAMFlag.variationIndex) === 1;
    var adConfig = (0,useSearchAdConfig/* useSearchAdConfig */.Z)(showGAMAds);
    var ref6 = (0,useSearchResults/* useSearchResults */.s)({
        initialFilters: initialFilters,
        initialPagination: initialPagination,
        seoSegmentId: seoSegmentId,
        isNationalPage: isNationalPage,
        showUserFilters: showUserFilters,
        initialSearchResults: {
            caregiverSearchResults: initialCaregiverSearchResults,
            providerSearchResults: initialProviderSearchResults
        }
    }), filters = ref6.filters, setFilters = ref6.setFilters, pagination = ref6.pagination, caregiverSearchResults = ref6.caregiverSearchResults, providerSearchResults = ref6.providerSearchResults, pageNumber = ref6.pageNumber, baseHandlePageClick = ref6.handlePageClick, baseFetchResults = ref6.fetchResults;
    var handlePageClick = function(newPage) {
        baseHandlePageClick(newPage, searchFiltersRef);
    };
    var filtersCtx = (0,react.useMemo)(function() {
        return {
            filters: filters,
            setFilters: function(filterVals) {
                setFilters(filterVals);
            },
            fetchResults: function(filterVals, resetPage) {
                baseFetchResults(filterVals, resetPage, searchFiltersRef);
            }
        };
    }, [
        filters,
        setFilters,
        baseFetchResults
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SegmentationFiltersContext/* SegmentationFiltersContext.Provider */.$I.Provider, {
        value: filtersCtx,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: [
                    asideLocation() === "TOP" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Aside, {}),
                    !isExtraSmallViewport && !isSmallViewport && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        mt: 4,
                        ref: searchFiltersRef,
                        sx: {
                            "& .MuiBox-root": {
                                mb: 0
                            }
                        },
                        children: [
                            isNationalPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationFilter/* default */.Z, {}),
                            showUserFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersPopover/* FiltersPopover */.g, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                mt: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        md: 8,
                        children: caregiverSearchResults.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NoResults/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    ref: searchResultRef
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    position: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration/* Illustration */.Q, {
                                            sx: {
                                                position: "absolute",
                                                right: {
                                                    md: "-325px",
                                                    xl: "-475px"
                                                },
                                                top: {
                                                    md: "525px"
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults/* SearchResults */.s, {
                                            items: caregiverSearchResults,
                                            renderItem: function(item, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaregiverCard/* CaregiverCard */.O, {
                                                    searchResult: item
                                                }, "product-".concat(i));
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemListSchema/* ItemListSchema */.Q, {
                                            searchResultType: "CAREGIVER",
                                            caregiverSearchResults: caregiverSearchResults,
                                            totalNumberOfResults: pagination.totalNumberOfResults,
                                            startIndex: pagination.startIndex
                                        }),
                                        showProductSchema && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSchema/* ProductSchema */.z, {
                                            avgReviewRating: avgReviewRating,
                                            totalReviewCount: totalReviewCount
                                        }),
                                        providerSearchResults.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            mt: 8,
                                            mb: 8,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: isExtraSmallViewport ? "h1" : "display2",
                                                    component: "h2",
                                                    mb: 3,
                                                    mt: 0,
                                                    mx: isExtraSmallViewport ? 3 : 0,
                                                    dangerouslySetInnerHTML: {
                                                        __html: sanitize_html_default()(he_default().decode(seoSegmentationDetails.smbHeadline))
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults/* SearchResults */.s, {
                                                    items: providerSearchResults,
                                                    renderItem: function(item, i) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SMBCard/* SMBCard */.F, {
                                                            searchResult: item
                                                        }, "product-".concat(i));
                                                    },
                                                    ads: adConfig
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalBusinessSchema/* LocalBusinessSchema */.O, {
                                                    results: providerSearchResults
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                            onPageClick: handlePageClick,
                                            pagination: pagination,
                                            segmentId: seoSegmentId,
                                            pageSelected: pageNumber
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: false,
                        md: 1
                    }),
                    asideLocation() === "BOTTOM" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        md: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Aside, {})
                    })
                ]
            }),
            (isExtraSmallViewport || isSmallViewport) && showUserFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersModal/* FiltersModal */.F, {
                isVisible: isVisible
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/page/HybridSearchDirectory/components/section/SearchResultsWithAsideSection.tsx







var SearchResultsWithAsideSection = function() {
    var seoSegmentationDetails = (0,SearchDirectoryDataContext/* useSearchDirectoryData */.Q)().seoSegmentationDetails;
    var ref = (0,useResponsive/* useResponsive */.F)(), isSmallViewport = ref.isSmallViewport, isLargeViewport = ref.isLargeViewport;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        bgcolor: "background.secondary",
        pt: 8,
        pb: 10,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container_Container/* default */.Z, {
            maxWidth: "lg",
            disableGutters: isSmallViewport || isLargeViewport,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: isSmallViewport ? "h1" : "display3",
                            component: "h2",
                            mb: 0,
                            mt: 0,
                            mx: isSmallViewport ? 3 : 0,
                            dangerouslySetInnerHTML: {
                                __html: seoSegmentationDetails.searchResultsHeader
                            },
                            sx: {
                                "& p:first-of-type": {
                                    margin: 0
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultsContainer, {
                        Aside: CaregiverStats/* CaregiverStats */.m
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/page/HybridSearchDirectory/index.tsx
















var ref = config_default()(), _publicRuntimeConfig = ref.publicRuntimeConfig, ITERABLE_MFE_API_KEY = _publicRuntimeConfig.ITERABLE_MFE_API_KEY, ITERABLE_MFE_PACKAGE_NAME = _publicRuntimeConfig.ITERABLE_MFE_PACKAGE_NAME, ITERABLE_MFE_GUEST_USER_ID = _publicRuntimeConfig.ITERABLE_MFE_GUEST_USER_ID, ITERABLE_TOP_BANNER_PLACEMENT_ID = _publicRuntimeConfig.ITERABLE_TOP_BANNER_PLACEMENT_ID;
var HybridSearchDirectory = function(param) {
    var pageData = param.pageData;
    var articlesList = (0,getArticlesList/* getArticlesList */.r)(pageData.seoArticlesList);
    var iterableEmbeddedGuestMessagingEnabled = (0,useFeatureFlag/* default */.Z)(constants/* UI_FEATURE_FLAGS.ITERABLE_EMBEDDED_GUEST_MESSAGING_ENABLED.id */.WV.ITERABLE_EMBEDDED_GUEST_MESSAGING_ENABLED.id);
    var getJWTRequest = (0,dist/* useOnJwtRequest */.YC)(ITERABLE_MFE_GUEST_USER_ID);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* IterableEmbeddedProvider */.qQ, {
        userId: ITERABLE_MFE_GUEST_USER_ID,
        packageName: ITERABLE_MFE_PACKAGE_NAME,
        apiKey: ITERABLE_MFE_API_KEY,
        placementIds: [
            ITERABLE_TOP_BANNER_PLACEMENT_ID
        ].map(Number),
        onJwtRequest: getJWTRequest,
        disabled: !(iterableEmbeddedGuestMessagingEnabled === null || iterableEmbeddedGuestMessagingEnabled === void 0 ? void 0 : iterableEmbeddedGuestMessagingEnabled.value),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchDirectoryDataContext/* SearchDirectoryDataProvider */.z, {
            pageData: pageData,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IterableBanner/* default */.Z, {
                    placementId: ITERABLE_TOP_BANNER_PLACEMENT_ID
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultsWithAsideSection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsSection/* ReviewsSection */.m, {
                    searchDirectoryTemplateType: "HYBRID"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection/* FAQSection */.v, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleSection.ArticleSection, {
                    articles: articlesList
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalLinkingSection/* InternalLinkingSection */.x, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbsSection/* BreadcrumbsSection */.L, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreGlobalFooter/* default */.Z, {
                    variant: "inverse"
                })
            ]
        })
    });
};
/* harmony default export */ var page_HybridSearchDirectory = (HybridSearchDirectory);


/***/ }),

/***/ 61083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ SMBCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19147);





var SMBCardCompact = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(346), __webpack_require__.e(6670), __webpack_require__.e(9852), __webpack_require__.e(1120)]).then(__webpack_require__.bind(__webpack_require__, 71120));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71120)
            ];
        }
    }
});
var SMBCardFull = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(346), __webpack_require__.e(6670), __webpack_require__.e(9852), __webpack_require__.e(7960)]).then(__webpack_require__.bind(__webpack_require__, 97960));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97960)
            ];
        }
    }
});
var SMBCard = function(param) {
    var searchResult = param.searchResult;
    var isSmallViewport = (0,_components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_2__/* .useResponsive */ .F)().isSmallViewport;
    // Skip profiles without a URL
    if (searchResult.profileURL === null) return null;
    var validSearchResult = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, searchResult), {
        profileURL: searchResult.profileURL
    });
    if (isSmallViewport) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SMBCardCompact, {
        searchResult: validSearchResult
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SMBCardFull, {
        searchResult: validSearchResult
    });
};


/***/ })

}]);